import axios from "axios";
import { waitForFirebaseUser } from "./firebaseAuthHelper";

const API_BASE = "https://modularobjects.com/mailserver/api/interior";

async function authConfig() {
  const user = await waitForFirebaseUser();
  const token = await user.getIdToken();

  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
}

const interiorLibraryAdminApi = {
  async listDefinitions(params = {}) {
    const config = await authConfig();
    const { data } = await axios.get(`${API_BASE}/definitions`, {
      ...config,
      params,
    });
    return data;
  },

  async getDefinition(id) {
    const config = await authConfig();
    const { data } = await axios.get(`${API_BASE}/definitions/${id}`, config);
    return data;
  },

  async createDefinition(payload) {
    const config = await authConfig();
    const { data } = await axios.post(`${API_BASE}/definitions`, payload, config);
    return data;
  },

  async updateDefinition(id, payload) {
    const config = await authConfig();
    const { data } = await axios.put(
      `${API_BASE}/definitions/${id}`,
      payload,
      config
    );
    return data;
  },

  async deleteDefinition(id) {
    const config = await authConfig();
    const { data } = await axios.delete(`${API_BASE}/definitions/${id}`, config);
    return data;
  },

    async listCatalogItems() {
    const config = await authConfig();
    const { data } = await axios.get(`${API_BASE}/items`, config);
    return data;
  },

  async listTemplates() {
  const config = await authConfig();
  const { data } = await axios.get(`${API_BASE}/templates`, config);
  return data;
},

async createTemplate(payload) {
  const config = await authConfig();
  const { data } = await axios.post(
    `${API_BASE}/templates`,
    payload,
    config
  );
  return data;
},

async deleteTemplate(id) {
  const config = await authConfig();
  const { data } = await axios.delete(`${API_BASE}/templates/${id}`, config);
  return data;
},

async listCategories(params = {}) {
  const config = await authConfig();
  const { data } = await axios.get(`${API_BASE}/categories`, {
    ...config,
    params,
  });
  return data;
},

async createCategory(payload) {
  const config = await authConfig();
  const { data } = await axios.post(`${API_BASE}/categories`, payload, config);
  return data;
},

async updateCategory(id, payload) {
  const config = await authConfig();
  const { data } = await axios.put(`${API_BASE}/categories/${id}`, payload, config);
  return data;
},

async deleteCategory(id) {
  const config = await authConfig();
  const { data } = await axios.delete(`${API_BASE}/categories/${id}`, config);
  return data;
},

async listMaterials(params = {}) {
  const config = await authConfig();
  const { data } = await axios.get(`${API_BASE}/materials`, {
    ...config,
    params,
  });
  return data;
},

async getMaterial(id) {
  const config = await authConfig();
  const { data } = await axios.get(`${API_BASE}/materials/${id}`, config);
  return data;
},

async createMaterial(payload) {
  const config = await authConfig();
  const { data } = await axios.post(`${API_BASE}/materials`, payload, config);
  return data;
},

async updateMaterial(id, payload) {
  const config = await authConfig();
  const { data } = await axios.put(`${API_BASE}/materials/${id}`, payload, config);
  return data;
},

async deleteMaterial(id) {
  const config = await authConfig();
  const { data } = await axios.delete(`${API_BASE}/materials/${id}`, config);
  return data;
},

async createMaterialTexture(materialId, payload) {
  const config = await authConfig();
  const { data } = await axios.post(
    `${API_BASE}/materials/${materialId}/textures`,
    payload,
    config
  );
  return data;
},

async updateMaterialTexture(textureId, payload) {
  const config = await authConfig();
  const { data } = await axios.put(
    `${API_BASE}/materials/textures/${textureId}`,
    payload,
    config
  );
  return data;
},

async deleteMaterialTexture(textureId) {
  const config = await authConfig();
  const { data } = await axios.delete(
    `${API_BASE}/materials/textures/${textureId}`,
    config
  );
  return data;
},

async uploadMaterialTexture(file) {
  const config = await authConfig();

  const formData = new FormData();
  formData.append("file", file);

  const { data } = await axios.post(
    `${API_BASE}/materials/upload-texture`,
    formData,
    {
      headers: {
        ...config.headers,
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return data;
},
};

export default interiorLibraryAdminApi;